import React from 'react';
import { Button, Row, Spinner } from 'react-bootstrap';
import { useAppSelector } from '../../store/store';
import { getDesignElements } from '../../store/selector/brand-elements.selector';
import { getFetchBrandElementsLoading } from '../../store/selector/common.selector';
import DesignElementsFonts from './DesignElementsFonts';
import ColorPicker from './ColorPicker';
import DesignElementsLogo from './DesignElementsLogo';

type IProps = {
    handleNext: () => void;
    handlePrev: () => void;
};

const DesignElements: React.FC<IProps> = ({ handleNext, handlePrev }) => {
    const designElementsData = useAppSelector(getDesignElements);
    const brandElementsLoading = useAppSelector(getFetchBrandElementsLoading);

    return (
        <div>
            <Row>
                <div className="brandMagic_content">
                    {brandElementsLoading ? (
                        <div className="d-flex justify-content-center mt-3">
                            <Spinner animation="border" />
                        </div>
                    ) : (
                        <>
                            <DesignElementsFonts designElementsData={designElementsData} />
                            <ColorPicker designElementsData={designElementsData} />
                            <DesignElementsLogo designElementsData={designElementsData} />
                        </>
                    )}
                </div>
                {!brandElementsLoading && (
                    <div className="d-flex justify-content-between align-items-center mt-3 brandMagic_buttons">
                        <Button onClick={handlePrev} variant="secondary" size="lg">
                            Back
                        </Button>
                        <Button
                            variant="primary"
                            size="lg"
                            onClick={() => {
                                handleNext();
                            }}
                        >
                            Next
                        </Button>
                    </div>
                )}
            </Row>
        </div>
    );
};

export default DesignElements;
